import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '../stores/auth';
import type { ReactNode } from 'react';

export function AuthGuard({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    // Preserve where the user was headed (e.g. a shared link landing on
    // /app/share?url=…) so Login can return them there after auth.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
